import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
    breakpoint: 
    {
        sm: "684px",
        m: "935px"
    }
}
